import { Slide, useScrollTrigger } from '@mui/material';

interface Props {
  children: React.ReactElement;
  scrollTarget: Node | undefined; //which component's scroll you want to listen to
}

/**
 * This component hides its children when you scroll down on the scrollTarget component and makes them re appear once
 * you scroll back to the top on the scrollTarget component
 * @param props 
 * @returns 
 */
export default function HideOnScroll(props: Props) {
  const { children, scrollTarget } = props;
  //listens to scroll on the specified component and returns true if scrolled down and false when scrolled to the top
  const trigger = useScrollTrigger({ target: scrollTarget, disableHysteresis: true, threshold: 0 });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}
